module.exports = "fragment ItemCategoryFragment on ItemCategory {\n  __typename\n  id\n  name\n  backgroundImageUrl\n  items {\n    ...ItemFragment\n  }\n}\n"